import { TABLET_WIDTH } from '../../constants';
import {
  GALLERY_LAYOUT_SLIDER,
  GRID_LAYOUT,
  SLIDER_LAYOUT,
  SLIDER_LAYOUT_MOBILE,
  COLLAGE_LAYOUT,
  TABLET_GRID_MAX_ITEM_IN_ROW,
  COLLAGE_LAYOUTS_OPTIONS,
} from '../../constants/proGalleryConstants';
import {
  LAYOUTS,
  DIRECTIONS,
  COLLAGE_POST_SIZE,
  MOBILE_COLLAGE_POST_SIZE,
  OVERLAY_EFFECTS,
  IMAGE_HOVER_EFFECTS,
} from '../../constants/settingsConstants';
import { getGalleryInfo } from './galleryHeight';
import store from '../../store';

/**
 * In Grid + Desktop layout - if layout is tablet, change num of columns to maximum 3 columns.
 * @param {*} numberOfImagesPerRow - num of columns that user selected.
 */
const checkColumnDesk = (numberOfImagesPerRow) => {
  const { isMobile } = store.getState().appReducer;
  if (isMobile && numberOfImagesPerRow < 4) {
    return {};
  }

  // if width desktop smaller then TABLET_WIDTH fix max column to 3
  if (window.innerWidth <= TABLET_WIDTH) {
    if (numberOfImagesPerRow > TABLET_GRID_MAX_ITEM_IN_ROW) {
      return {
        numberOfImagesPerRow: TABLET_GRID_MAX_ITEM_IN_ROW,
      };
    }
  } else {
    // Return num of columns to user choise
    return {
      numberOfImagesPerRow,
    };
  }

  return {};
};

/**
 * Get key and value from styleParams and return the curret proGallery option.
 * @param {*} key - key of style params
 * @param {*} value - value of that key
 */
const convertSettingParamsToGalleryParams = (key, value) => {
  let obj = {};
  if (value === undefined) {
    return {};
  }

  switch (key) {
    case 'cornerRadiusFeed':
    case 'cornerRadiusHashtag':
      obj = { itemBorderRadius: value };
      break;
    case 'spacingGrid':
    case 'spacingItemsGridHashtag':
    case 'm_spacingItemsGrid':
    case 'm_spacingItemsGridHashtag':
    case 'spacingSlider':
    case 'spacingItemsSliderHashtag':
    case 'm_spacingItemsSlider':
    case 'm_spacingItemsSliderHashtag':
    case 'spacingCollage':
    case 'spacingItemsCollageHashtag':
    case 'm_spacingItemsCollageHashtag':
    case 'm_spacingItemsCollage':
      obj = { imageMargin: value };
      break;
    case 'gallerySpacingGrid':
    case 'm_gallerySpacingGrid':
    case 'gallerySpacingCollage':
    case 'm_gallerySpacingCollage':
    case 'gallerySpacingSlider':
    case 'm_gallerySpacingSlider':
    case 'gallerySpacingGridHashtag':
    case 'm_gallerySpacingGridHashtag':
    case 'gallerySpacingCollageHashtag':
    case 'm_gallerySpacingCollageHashtag':
    case 'gallerySpacingSliderHashtag':
    case 'm_gallerySpacingSliderHashtag':
      obj = { galleryMargin: value };
      break;
    case 'numberOfColumnsGrid':
    case 'numberOfColumnsGridHashtag':
    case 'm_numberOfColumnsGrid':
    case 'm_numberOfColumnsGridHashtag':
      obj = { numberOfImagesPerRow: value, m_numberOfImagesPerRow: value };
      break;
    case 'numberOfRowsGrid':
    case 'numberOfRowsGridHashtag':
    case 'm_numberOfRowsGrid':
    case 'm_numberOfRowsGridHashtag':
      obj = { numRows: value };
      break;
    case 'direction':
      obj = { isRTL: value && value === DIRECTIONS.RTL ? true : false };
      break;
    case 'isLoopImages':
    case 'isLoopImagesHashtag':
      obj = { slideshowLoop: value };
      break;
    case 'isSlideAutomatically':
    case 'isSlideAutomaticallyHashtag':
      if (window.Wix.Utils.getViewMode() === 'editor') {
        obj = {};
      } else {
        obj = { isAutoSlideshow: value };
      }
      break;
    case 'numberOfColumnsSlider':
    case 'numberOfColumnsSliderHashtag':
    case 'm_numberOfColumnsSlider':
    case 'm_numberOfColumnsSliderHashtag':
      obj = {
        countItemsSlider: value,
        cubeRatio: `${100 / value}%/100%`,
      };
      break;
    case 'sliderArrowsSize':
    case 'sliderArrowsPosition':
    case 'sliderArrowsPadding':
    case 'm_sliderArrowsSize':
    case 'm_sliderArrowsPosition':
    case 'm_sliderArrowsPadding':
      key = key.replace(/sliderA|m_sliderA/, 'a');
      obj = {
        [key]: value,
      };
      break;
    case 'itemBorderColor':
      obj =
        value && value.value
          ? {
              itemBorderColor: value.value,
            }
          : {};
      break;
    case 'collagePostSize':
    case 'collagePostSizeHashtag':
      obj =
        value === COLLAGE_POST_SIZE.LARGE
          ? COLLAGE_LAYOUTS_OPTIONS.LARGE
          : value === COLLAGE_POST_SIZE.MEDIUM
          ? COLLAGE_LAYOUTS_OPTIONS.MEDIUM
          : value === COLLAGE_POST_SIZE.SMALL
          ? COLLAGE_LAYOUTS_OPTIONS.SMALL
          : COLLAGE_LAYOUTS_OPTIONS.XSMALL;
      break;
    case 'm_collagePostSizeHashtag':
    case 'm_collagePostSize':
      obj =
        value === MOBILE_COLLAGE_POST_SIZE.LARGE
          ? COLLAGE_LAYOUTS_OPTIONS.LARGE
          : value === MOBILE_COLLAGE_POST_SIZE.MEDIUM
          ? COLLAGE_LAYOUTS_OPTIONS.MEDIUM
          : value === MOBILE_COLLAGE_POST_SIZE.SMALL
          ? COLLAGE_LAYOUTS_OPTIONS.SMALL
          : COLLAGE_LAYOUTS_OPTIONS.XSMALL;
      break;
    case 'isShowMoreBtn':
    case 'm_isShowMoreBtn':
    case 'isShowMoreBtnHashtag':
    case 'm_isShowMoreBtnHashtag':
    case 'isShowMoreBtnCollage':
    case 'isShowMoreBtnCollageHashtag':
    case 'm_isShowMoreBtnCollageHashtag':
    case 'm_isShowMoreBtnCollage':
      obj = { isShowMoreBtn: value };
      break;
    case 'rowsLoadMoreCollage':
    case 'm_rowsLoadMoreCollage':
    case 'rowsLoadMoreCollageHashtag':
    case 'm_rowsLoadMoreCollageHashtag':
      obj = { countBlocksDisplay: value };
      break;
    case 'ratio':
      obj = { cubeRatio: value };
      break;
    case 'overlayEffect':
      if (value === OVERLAY_EFFECTS.FADE_IN) {
        obj = { overlayAnimation: 'FADE_IN' };
      } else {
        obj = {};
      }
      break;
    case 'imageHoverEffect':
      if (value === IMAGE_HOVER_EFFECTS.ZOOM_IN) {
        obj = { imageHoverAnimation: 'ZOOM_IN' };
      } else if (value === IMAGE_HOVER_EFFECTS.GRAYSCALE) {
        obj = { imageHoverAnimation: 'GRAYSCALE' };
      } else if (value === IMAGE_HOVER_EFFECTS.COLOR_IN) {
        obj = { imageHoverAnimation: 'COLOR_IN' };
      } else {
        obj = {};
      }
      break;
    default:
      obj = { [key]: value };
      break;
  }
  //
  //
  return obj;
};

/**
 * Get StyleParams by layout type.
 * @param {*} styleParamsByLayout - Style params that needed to current layout
 * @param {*} layoutOptions - Options by layout
 */
const getSettingOptions = (
  layoutOptions,
  globalStyleParamsOptions,
  styleParamsByLayout,
) => {
  const { isMobile } = store.getState().appReducer;
  const settingsReducer = store.getState().settingsReducer;

  const type = isMobile ? 'MOBILE' : 'DESK';
  const newOptions = {
    ...layoutOptions,
    ...func(globalStyleParamsOptions, settingsReducer),
    ...func(styleParamsByLayout[type], settingsReducer),
  };

  return newOptions;
};

const func = (arr, state) => {
  let newObj = {};
  arr.map((key) => {
    if (state[key] !== null) {
      newObj = {
        ...newObj,
        ...convertSettingParamsToGalleryParams(key, state[key]),
      };
    }
  });
  return newObj;
};

export const getGalleryMargin = (options) => {
  let margin = 0;
  if (options && options.galleryMargin) {
    margin = options.galleryMargin;
    delete options.galleryMargin;
  }
  return margin;
};

/**
 * Return current proGallery options by layout type (Grid, Collage, Slider)
 */
export const getCurrentSettings = (type, defaultDesignOptions = {}) => {
  const { galleryLayout, styleParamsByLayout } = getGalleryInfo(type);
  const { isMobile } = store.getState().appReducer;

  let options;
  switch (galleryLayout) {
    case LAYOUTS.GRID:
      options = {
        ...defaultDesignOptions,
        ...getSettingOptions(
          GRID_LAYOUT,
          styleParamsByLayout.GLOBAL,
          styleParamsByLayout.GRID,
        ),
      };
      options = {
        ...options,
        ...checkColumnDesk(options.numberOfImagesPerRow),
      };
      break;
    case LAYOUTS.COLLAGE:
      options = {
        ...defaultDesignOptions,
        ...getSettingOptions(
          COLLAGE_LAYOUT,
          styleParamsByLayout.GLOBAL,
          styleParamsByLayout.COLLAGE,
        ),
      };
      break;
    case LAYOUTS.SLIDER:
      options = {
        ...defaultDesignOptions,
        ...getSettingOptions(
          isMobile ? SLIDER_LAYOUT_MOBILE : SLIDER_LAYOUT,
          styleParamsByLayout.GLOBAL,
          styleParamsByLayout.SLIDER,
        ),
      };
      break;
    default:
      break;
  }
  return options;
};

// In case of endless scroll in slider layout get the right index
export const getCurrentIdxForEndlessScroll = (idx, length) => {
  if (idx >= 0 && idx < length) return idx;
  return getCurrentIdxForEndlessScroll(idx - length, length);
};
